var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.showBasicSubscriptionCard
        ? _c(
            "div",
            {
              staticClass: "card mt-3",
              attrs: { "header-bg-variant": "white" }
            },
            [
              _c("div", { staticClass: "card-body" }, [
                _c("div", { staticClass: "row mb-4" }, [
                  _c("div", { staticClass: "col-auto" }, [
                    _c("h5", { staticClass: "mb-0 pb-0" }, [
                      _c(
                        "span",
                        { attrs: { "data-test-hook": "basic-plan-name" } },
                        [_vm._v(" " + _vm._s(_vm.$t("xMobileLinkBasic")) + " ")]
                      )
                    ])
                  ])
                ]),
                _c("div", { staticClass: "row mb-2" }, [
                  _c("div", { staticClass: "col" }, [
                    _c(
                      "span",
                      { attrs: { "data-test-hook": "plan-cost-header-text" } },
                      [_vm._v(" " + _vm._s(_vm.$t("xPlanStatus")) + " ")]
                    )
                  ])
                ]),
                _c("div", { staticClass: "row mb-4" }, [
                  _c("div", { staticClass: "col" }, [
                    _vm.country.includes(
                      _vm.productsOnBasicSubscription[0].country
                    )
                      ? _c(
                          "strong",
                          { attrs: { "data-test-hook": "plan-cost" } },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t("xCurrentlyNotSubscribedToPlan")
                                ) +
                                " "
                            )
                          ]
                        )
                      : _c(
                          "strong",
                          { attrs: { "data-test-hook": "plan-cost" } },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.$t("xMLPNotAvailableInYourRegion")) +
                                " "
                            )
                          ]
                        )
                  ])
                ]),
                _c(
                  "div",
                  {
                    staticClass: "accordion",
                    staticStyle: { width: "100%" },
                    attrs: { role: "tablist" }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "accordion-wrapper",
                        staticStyle: {
                          border: "1px solid lightgrey",
                          padding: "10px",
                          "border-radius": "10px"
                        }
                      },
                      [
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "b-toggle",
                                rawName:
                                  "v-b-toggle.collapse-hasProductNoSubscription",
                                modifiers: {
                                  "collapse-hasProductNoSubscription": true
                                }
                              }
                            ]
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "row align-items-center no-gutters"
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "col align-items-center" },
                                  [
                                    _c("i", {
                                      staticClass:
                                        "fa-regular fa-circle-info pr-2"
                                    }),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(_vm.$t("xProductsAndFeatures"))
                                      )
                                    ])
                                  ]
                                ),
                                _vm._m(0)
                              ]
                            )
                          ]
                        ),
                        _c(
                          "b-collapse",
                          {
                            attrs: { id: "collapse-hasProductNoSubscription" }
                          },
                          [
                            _c("div", { staticClass: "row" }, [
                              _c("div", { staticClass: "col" }, [
                                _c("hr", { staticClass: "mx-0 px-0" })
                              ])
                            ]),
                            _vm.productsOnBasicSubscription !== undefined &&
                            _vm.productsOnBasicSubscription !== null &&
                            _vm.productsOnBasicSubscription.find(
                              apparatus =>
                                apparatus.apparatusType === _vm.hsbApparatusType
                            )
                              ? _c("div", [
                                  _c("div", { staticClass: "row mb-2" }, [
                                    _c("div", { staticClass: "col" }, [
                                      _c("p", { staticClass: "mb-0 pb-0" }, [
                                        _c(
                                          "strong",
                                          {
                                            attrs: {
                                              "data-test-hook":
                                                "products-included-text"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "xProductsWithBasicFeatures"
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ])
                                    ])
                                  ]),
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col-0" }, [
                                      _c(
                                        "ul",
                                        {
                                          staticStyle: {
                                            "list-style-type": "none",
                                            "padding-inline-start": "13px"
                                          },
                                          attrs: {
                                            id:
                                              "productsCoveredSingleHomePremium"
                                          }
                                        },
                                        _vm._l(
                                          _vm.productsOnBasicSubscription,
                                          function(apparatus, index) {
                                            return _c("li", { key: index }, [
                                              apparatus.apparatusType ===
                                              _vm.hsbApparatusType
                                                ? _c(
                                                    "div",
                                                    { staticClass: "mb-1" },
                                                    [
                                                      _c("i", {
                                                        class: _vm.getApparatusIcon(
                                                          apparatus.apparatusType
                                                        )
                                                      }),
                                                      _vm._v(
                                                        "  " +
                                                          _vm._s(
                                                            apparatus.apparatusName
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ])
                                          }
                                        ),
                                        0
                                      )
                                    ])
                                  ]),
                                  _c("div", { staticClass: "row mb-2" }, [
                                    _c("div", { staticClass: "col" }, [
                                      _c("p", { staticClass: "mb-0 pb-0" }, [
                                        _c(
                                          "strong",
                                          {
                                            attrs: {
                                              "data-test-hook":
                                                "features-included-text"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "xFeaturesIncludedInBasicPlan"
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ])
                                    ])
                                  ]),
                                  _c("div", { staticClass: "row mb-3" }, [
                                    _c(
                                      "div",
                                      { staticClass: "col icon-and-text" },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "fa-kit fa-fw fa-generator"
                                        }),
                                        _c(
                                          "span",
                                          {
                                            attrs: {
                                              "data-test-hook":
                                                "features-included-list"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "xFeaturesIncludedWiFiAnnuallySubscriptionFeature1"
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ])
                                ])
                              : _vm._e(),
                            _vm.productsOnBasicSubscription !== undefined &&
                            _vm.productsOnBasicSubscription !== null &&
                            _vm.productsOnBasicSubscription.find(
                              apparatus =>
                                apparatus.apparatusType ===
                                _vm.fuelTankApparatusType
                            )
                              ? _c("div", [
                                  _c("div", { staticClass: "row mb-2" }, [
                                    _c("div", { staticClass: "col" }, [
                                      _c("p", { staticClass: "mb-0 pb-0" }, [
                                        _c(
                                          "strong",
                                          {
                                            attrs: {
                                              "data-test-hook":
                                                "products-included-text"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "xProductsNotSupported"
                                                  )
                                                ) +
                                                " "
                                            )
                                          ]
                                        )
                                      ])
                                    ])
                                  ]),
                                  _c("div", { staticClass: "row" }, [
                                    _c("div", { staticClass: "col-0" }, [
                                      _c(
                                        "ul",
                                        {
                                          staticStyle: {
                                            "list-style-type": "none",
                                            "padding-inline-start": "13px"
                                          },
                                          attrs: {
                                            id:
                                              "productsCoveredSingleHomePremium"
                                          }
                                        },
                                        _vm._l(
                                          _vm.productsOnBasicSubscription,
                                          function(apparatus, index) {
                                            return _c("li", { key: index }, [
                                              apparatus.apparatusType ===
                                              _vm.fuelTankApparatusType
                                                ? _c(
                                                    "div",
                                                    { staticClass: "mb-1" },
                                                    [
                                                      _c("i", {
                                                        class: _vm.getApparatusIcon(
                                                          apparatus.apparatusType
                                                        )
                                                      }),
                                                      _vm._v(
                                                        "  " +
                                                          _vm._s(
                                                            apparatus.apparatusName
                                                          ) +
                                                          " "
                                                      )
                                                    ]
                                                  )
                                                : _vm._e()
                                            ])
                                          }
                                        ),
                                        0
                                      )
                                    ])
                                  ])
                                ])
                              : _vm._e(),
                            _c("div", { staticClass: "row mt-0 mb-2" }, [
                              _c("div", { staticClass: "col" }, [
                                _c("p", { staticClass: "mb-0 pb-0" }, [
                                  _c(
                                    "strong",
                                    {
                                      attrs: {
                                        "data-test-hook":
                                          "features-included-text"
                                      }
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.$t("xFeaturesNotIncluded")
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ])
                              ])
                            ]),
                            _vm.productsOnBasicSubscription !== undefined &&
                            _vm.productsOnBasicSubscription !== null &&
                            _vm.productsOnBasicSubscription.find(
                              apparatus =>
                                apparatus.apparatusType === _vm.hsbApparatusType
                            )
                              ? _c("div", { staticClass: "row mb-3" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col icon-and-text" },
                                    [
                                      _c("i", {
                                        staticClass: "fa-kit fa-fw fa-generator"
                                      }),
                                      _c(
                                        "span",
                                        {
                                          attrs: {
                                            "data-test-hook":
                                              "features-included-list"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "xFeatureNotIncludedFeaturesHSB"
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm.productsOnBasicSubscription !== undefined &&
                            _vm.productsOnBasicSubscription !== null &&
                            _vm.productsOnBasicSubscription.find(
                              apparatus =>
                                apparatus.apparatusType ===
                                _vm.fuelTankApparatusType
                            )
                              ? _c("div", { staticClass: "row mb-3" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col icon-and-text" },
                                    [
                                      _c(
                                        "span",
                                        {
                                          attrs: {
                                            "data-test-hook":
                                              "features-included-list"
                                          }
                                        },
                                        [
                                          _c("i", {
                                            class: _vm.getApparatusIcon(
                                              _vm.fuelTankApparatusType
                                            )
                                          }),
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t(
                                                  "xFeatureNotIncludedFeaturesFuelTank"
                                                )
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ])
                              : _vm._e()
                          ]
                        )
                      ],
                      1
                    )
                  ]
                ),
                _vm.country.includes(_vm.productsOnBasicSubscription[0].country)
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-warning mt-3",
                        attrs: {
                          type: "button",
                          "data-test-hook": "openSubscribePremiumMonitoringBtn",
                          disabled: _vm.disableUpgradeButton
                        },
                        on: {
                          click: function($event) {
                            return _vm.openSubscribePremium()
                          }
                        }
                      },
                      [_vm._v(" " + _vm._s(_vm.$t("xUpgradePremium")) + " ")]
                    )
                  : _vm._e()
              ])
            ]
          )
        : _vm._e(),
      _c("AccountNeedsAttentionModal"),
      _c("PremiumEnrollmentBeforeYouUpgradeModal", {
        attrs: {
          apparatusesIncludedInUpgrade: _vm.productsOnBasicSubscription
        },
        on: { openSubscriptionModal: _vm.openSubscriptionModal }
      }),
      _c("UpgradeSubscriptionsModal", {
        attrs: {
          "modal-id": "upgrade-subscription-modal-hsb",
          "apparatus-id": _vm.generatorId,
          "apparatus-list": _vm.apparatusesToUpgrade,
          accountProfile: _vm.accountProfile
        }
      })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-auto" }, [
      _c("i", { staticClass: "fas fa-chevron-down when-closed" }),
      _c("i", { staticClass: "fas fa-chevron-up when-open" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }